






















































import { Component, Vue } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import { getOrderList } from '../api/orders'
import singleCard from '@/components/dashboard/singleValue.vue'
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  name: 'Orders',
  components: { singleCard }
})
export default class extends Vue {
  isLoading = false
  private items: any[] = []
  created() {
    this.getData()
  }

  openInvoice(invoiceId: string, invoiceHash: string) {
    //
    window.open('https://cp.3dprintit.de/files/invoice/' + invoiceId + '/' + invoiceHash, '_blank')
  }
  openCustomerPage(customer_id: number) {
    //TODO: push with id of customer
    this.$router.push('/customers')
  }
  async getData() {
    try {
      const answer = await getOrderList()
      if (answer.data.data != null && answer.data.data.length != 0) {
        console.log(answer.data)
        for (let index = 0; index < answer.data.data.length; index++) {
          const element = answer.data.data[index]
          console.log(element)
          const orderItem = {
            order_id: element.order_id,
            invoice_no: element.invoice_no,
            invoiceHash: element.hash,
            customer_id: element.customer_id,
            name: element.firstname + ' ' + element.lastname,
            email: element.email,
            price: element.price,
            status: this.StatusState(element.order_status_id),
            date_added: element.date_added,
            date_modified: element.date_modified
          }
          this.items.push(orderItem)
        }
      }
      console.log(this.items)
      this.noEntriesMessage = 'Keine Daten auf dem Server vorhanden.'
      this.tableDataLoading = false
    } catch (error) {
      if (error.toString().includes('404')) {
        this.tableDataLoading = false
      } else if (error.toString().includes('403')) {
        this.noEntriesMessage = 'Keine Berechtigung.'
        this.tableDataLoading = false
        this.$store.state.authorized = false
        this.$router.push({ path: '/' })
      } else {
        console.log(error)
        this.tableDataLoading = false
      }
    }
  }
  private tableDataLoading = true
  private noEntriesMessage = 'Daten konnten nicht geladen werden.'

  private search = ''
  private sortStyle = 0
  private statusStates = [
    { name: 'Bestellung angefangen', color: 'rgb(220,180,20)', value: 1 },
    { name: 'Warte auf Zahlungseingang', color: 'rgb(220,180,20)', value: 2 },
    { name: 'Bezahlung erhalten', color: 'rgb(220,180,20)', value: 3 },
    { name: 'In Bearbeitung', color: 'rgb(220,180,20)', value: 4 },
    { name: 'Versendet', color: 'green', value: 5 },
    { name: 'Abgeschlossen', color: 'black', value: 6 },
    { name: 'Ersattung beantragt', color: 'red', value: 8 },
    { name: 'Ersattet', color: 'red', value: 9 },
    { name: 'Ersattung abgelehnt', color: 'red', value: 10 },
    { name: 'Rückbuchung', color: 'red', value: 11 }
  ]
  StatusState(input: number) {
    const c = this.statusStates.find(state => {
      if (state.value == input) return state
    })
    if (c != undefined) return c
    else return { name: 'error', color: 'purple', value: '-1' }
  }
  openOrderSummary(row: any) {
    this.$router.push({ path: `/order/summary/${row.order_id}` })
  }

  private headers = [
    {
      sortable: true,
      text: 'Bestell-Nr',
      value: 'invoice_no'
    },
    {
      sortable: true,
      text: 'Kunde',
      value: 'name'
    },
    {
      sortable: true,
      text: 'Preis',
      value: 'price'
    },
    {
      sortable: true,
      text: 'Status',
      value: 'status'
    },
    {
      sortable: true,
      text: 'Bestelldatum',
      value: 'date_added'
    },
    {
      sortable: true,
      text: 'Änderungsdatum',
      value: 'date_modified'
    },
    {
      sortable: true,
      text: 'Rechnung',
      value: 'invoice'
    }
  ]
}
